import React, { FC, useState } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FrShareSvg from '@src/svgs/fr-reply-right.svg';
import { Tooltip } from '@src/components/Tooltip';
import { Props } from './props';

export const Share: FC<Props> = ({ copyText, isUserVerified }) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleCopyText = () => {
    if (isUserVerified) {
      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }
  };

  return (
    <Tooltip placement="top" overlay="Link copied to clipboard" visible={isCopied}>
      <CopyToClipboard onCopy={handleCopyText} text={copyText}>
        <div
          className={classnames(
            'talent-feed-item-actions__item',
            !isUserVerified && 'talent-feed-item-actions__item--disabled',
          )}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <Svg className="talent-feed-item-actions__icon" src={FrShareSvg} />
          <span>Copy URL</span>
        </div>
      </CopyToClipboard>
    </Tooltip>
  );
};
